export default { commitHash: '', version: '' };
